import axios, { GenericAbortSignal } from 'axios';
import axiosRetry from 'axios-retry';
import { NUMBER_OF_GET_CART_API_RETRIES } from 'core/constants/shopping-cart.constants';
import { EHttpStatusCode } from 'core/model/enums/http.enum';
import { IServiceSuccess } from 'core/model/interfaces/service.interface';
import { https } from 'core/services/https';
import { IGetShoppingCartDTO, IGetShoppingCartParams, IPutShoppingCartRequestParams } from './shopping-cart.dto';

export const baseUrl = '/v1/cart';
export const shoppingCartData = {
  getShoppingCart: async (
    customerId: number,
    params?: IGetShoppingCartParams,
    shouldRetry?: boolean,
  ): Promise<IGetShoppingCartDTO> => {
    axiosRetry(https, { retries: 0 });
    const data = await https.get<IGetShoppingCartDTO>(`${baseUrl}`, {
      params,
      'axios-retry': {
        retries: shouldRetry ? NUMBER_OF_GET_CART_API_RETRIES : 0,
        retryDelay: axiosRetry.exponentialDelay,
        retryCondition: error =>
          axios.isAxiosError(error) && error.response?.status === EHttpStatusCode.InternalServerError,
      },
      headers: { 'Gtm-Customer-id': customerId },
    });
    return data;
  },

  putShoppingCart: async (
    params: IPutShoppingCartRequestParams,
    customerId: number,
    signal?: GenericAbortSignal,
  ): Promise<IServiceSuccess> => {
    const { externalProductId, ...restofParams } = params;
    return https.put<IServiceSuccess>(`${baseUrl}/items/${externalProductId}`, restofParams, {
      signal,
      headers: { 'Gtm-Customer-Id': customerId },
    });
  },

  deleteProductShoppingCart: async (productId: string, customerId: number): Promise<IServiceSuccess> =>
    https.delete<IServiceSuccess>(`${baseUrl}/items/${productId}`, {
      headers: { 'Gtm-Customer-id': customerId },
    }),
};
